import i18n from '@/utils/i18n'

export function getSignupErrorMessage (code, fallback) {
  const map = {
    2009: i18n.t('auth.errorDuplicateLoginId'),
    2021: i18n.t('auth.errorDuplicateNickname'),
    2023: i18n.t('auth.errorReferralInvalid'),
    2035: i18n.t('auth.errorDuplicateIp')
  }
  return map[Number(code)] || fallback || i18n.t('auth.signupFail')
}

export function validateSignupForm (form) {
  const loginid = String(form.loginid || '').trim()
  const name = String(form.name || '').trim()
  const loginpwd = String(form.loginpwd || '')
  const loginpwdConfirm = String(form.loginpwdConfirm || '')
  const pcode = String(form.pcode || '').trim()

  if (!loginid) {
    return i18n.t('auth.errorLoginIdRequired')
  }
  if (!/^[a-zA-Z0-9]{4,12}$/.test(loginid)) {
    return i18n.t('auth.errorLoginIdFormat')
  }
  if (!name) {
    return i18n.t('auth.errorNicknameRequired')
  }
  if (name.length < 2 || name.length > 12) {
    return i18n.t('auth.errorNicknameLength')
  }
  if (!loginpwd) {
    return i18n.t('auth.errorPasswordRequired')
  }
  if (loginpwd.length < 4 || loginpwd.length > 20) {
    return i18n.t('auth.errorPasswordLength')
  }
  if (!loginpwdConfirm) {
    return i18n.t('auth.errorPasswordConfirmRequired')
  }
  if (loginpwd !== loginpwdConfirm) {
    return i18n.t('auth.errorPasswordMismatch')
  }
  if (!pcode) {
    return i18n.t('auth.errorReferralRequired')
  }
  return ''
}
